import { render, staticRenderFns } from "./TaskNodeConfig.vue?vue&type=template&id=2f815f76&scoped=true"
import script from "./TaskNodeConfig.vue?vue&type=script&lang=js"
export * from "./TaskNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskNodeConfig.vue?vue&type=style&index=0&id=2f815f76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f815f76",
  null
  
)

export default component.exports